
import { NotFound } from './NotFound';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import * as $ from 'jquery';

import { Location } from '@angular/common';
import 'rxjs/add/operator/catch';
import {Globals} from '../globals';
import { BackRoutingStateService } from '../back-routing-state.service';
@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {
  NotFound:NotFound;
  previousRoute: string;
  lang = localStorage.getItem('lang')?localStorage.getItem('lang'):'hy'
  constructor(private http: HttpClient , private routingState: BackRoutingStateService,
     public globals: Globals, private route: ActivatedRoute , public _router:Router , public _location:Location) {
    routingState.loadRouting();
     }

  ngOnInit() {
    this.http.get<NotFound>(this.globals.urlMain +'error').subscribe(data => {
      this.NotFound = data;

    }  );
  }
 
  backClicked() {
      console.log(this.routingState.getHistory())
  }
 
}
